import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function PainPoints() {
  const pains = ['Llegas a la cancha sin saber exactamente qué ejercicio vas a dar', 'Tus jugadores no progresan porque no hay una secuencia clara de aprendizaje', 'El 60% abandona antes del año y no sabes cómo frenarlo', 'Cuando hay partido o feriado pierdes la continuidad de la planificación', 'No puedes justificar un aumento de precio ante los padres', 'Jugadores de distintos niveles juntos igual a caos en la sesión', 'Sin sistema de evaluación formal nadie ve el progreso y todos se desmotivan'];
  return <section className="py-20 px-4 bg-dark-DEFAULT" data-id="element-166">
      <div className="max-w-4xl mx-auto" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-168">
          <h2 className="text-4xl md:text-5xl font-bebas mb-4" data-id="element-169">
            <span className="text-brand-gold" data-id="element-170">
              Si eres entrenador de vóley,{' '}
            </span>
            <span className="text-brand-DEFAULT" data-id="element-171">
              esto te va a sonar familiar:
            </span>
          </h2>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-172">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start space-x-4 bg-dark-card border-l-4 border-red-500 p-5 rounded-lg shadow-[0_0_15px_rgba(239,68,68,0.08)]" data-id="element-173">
              <XCircleIcon className="text-red-500 mt-0.5 flex-shrink-0" size={24} data-id="element-174" />
              <p className="text-white text-lg" data-id="element-175">{pain}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-176">
          <h3 className="text-4xl md:text-5xl font-bebas text-brand-gold" data-id="element-177">
            ¿Cuántas sesiones más vas a improvisar?
          </h3>
        </motion.div>
      </div>
    </section>;
}